// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breakdown .com-mod-module-header[data-v-20f8dbf6] {
  margin-top: 13px;
  margin-bottom: 0px;
  font-size: 18px;
  color: #333;
  font-family: "Avenir Next LT W01 Demi", Arial;
}
.breakdown .com-mod-module-header-individual[data-v-20f8dbf6] {
  font-size: 26px;
  color: #333;
  font-family: 'AvenirNextLTW01-Regular', Arial;
}
.breakdown .breakdown-chart-legend[data-v-20f8dbf6] {
  margin-bottom: 30px;
}
.breakdown .adjust-down[data-v-20f8dbf6] {
  margin-top: 20px;
}
.breakdown .breakdown-chart[data-v-20f8dbf6] {
  display: block;
  height: 126px;
  width: 126px;
}
@media (max-width: 770px) {
.breakdown .breakdown-chart[data-v-20f8dbf6] {
    height: auto;
    width: 90%;
}
}
.breakdown .chart-title[data-v-20f8dbf6] {
  color: #666666;
  font-family: 'Avenir Next LT W01 Demi', Arial;
  font-size: 12px;
  margin-top: 12px;
  margin-bottom: 12px;
}
.breakdown .adjust-date[data-v-20f8dbf6] {
  margin: 10px 0px 10px 0px;
}
.breakdown .app-title[data-v-20f8dbf6] {
  margin-bottom: 0px;
}
.breakdown .com-mod-section-header[data-v-20f8dbf6] {
  margin: 15px 0px 20px 0px;
}
.breakdown .com-mod-table-label[data-v-20f8dbf6] {
  color: #666666;
}
.breakdown .link-container[data-v-20f8dbf6] {
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
  margin: 10px 0 10px 0;
}
.breakdown .sector-exposure img[data-v-20f8dbf6] {
  height: 125px;
}
.breakdown .sector-exposure .chart-legend-container[data-v-20f8dbf6] {
  margin-bottom: 20px;
}
.breakdown .toggle-section-header[data-v-20f8dbf6] {
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
  margin: 15px 0px 20px 0px;
}
.breakdown .flush-top[data-v-20f8dbf6] {
  margin-top: 0 !important;
}
.breakdown .table[data-v-20f8dbf6] {
  margin-top: 10px;
}
.breakdown li.active h3.com-mod-tab-module-header span.com-mod-table-label[data-v-20f8dbf6] {
  color: #000;
}
.breakdown li h3.com-mod-tab-module-header span.com-mod-table-label[data-v-20f8dbf6] {
  color: #eee;
}
.breakdown .white-arrow-down[data-v-20f8dbf6] {
  border-bottom: 2px solid white;
  border-right: 2px solid white;
  height: 8px;
  width: 8px;
  margin: 3px;
  background-color: rgba(0, 0, 0, 0);
  display: inline-block;
  transform: rotateZ(45deg);
}
.breakdown .white-arrow-right[data-v-20f8dbf6] {
  border-bottom: 2px solid white;
  border-right: 2px solid white;
  height: 8px;
  width: 8px;
  margin: 3px;
  background-color: rgba(0, 0, 0, 0);
  display: inline-block;
  transform: rotateZ(-45deg);
}
.breakdown #underlying-funds[data-v-20f8dbf6] {
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
  color: #333;
  font-size: 14px;
}
.breakdown #underlying-funds .additional-information[data-v-20f8dbf6] {
  margin-bottom: 20px;
}
.breakdown #underlying-funds .objective[data-v-20f8dbf6] {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 8px;
}
.breakdown #underlying-funds .funds[data-v-20f8dbf6] {
  list-style: none;
  padding: 0;
}
.breakdown #underlying-funds .funds .fund[data-v-20f8dbf6] {
  font-weight: 400;
  line-height: 20px;
  color: #1d5799 !important;
  margin-bottom: 3px;
}
.breakdown #underlying-funds .funds .fund[data-v-20f8dbf6]:last-of-type {
  margin-bottom: 25px;
}
.breakdown #underlying-funds dl[data-v-20f8dbf6] {
  margin-bottom: 0;
}
.breakdown #underlying-funds dl dd:last-of-type .funds[data-v-20f8dbf6] {
  margin-bottom: 0;
}
.breakdown #underlying-funds dl dd:last-of-type .funds .fund[data-v-20f8dbf6]:last-of-type {
  margin-bottom: 0;
}
@media (max-width: 768px) {
.breakdown .pull-right[data-v-20f8dbf6] {
    float: none !important;
}
.breakdown .flush-top[data-v-20f8dbf6] {
    margin-bottom: 10px;
}
.breakdown .flush-left-responsive[data-v-20f8dbf6] {
    padding-left: 0;
}
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/breakdown-module.less","webpack://./BreakdownBond.vue"],"names":[],"mappings":"AAAA;EAEE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,6CAAA;ACAF;ADNA;EASE,eAAA;EACA,WAAA;EACA,6CAAA;ACAF;ADXA;EAcE,mBAAA;ACAF;ADdA;EAiBE,gBAAA;ACAF;ADjBA;EAoBE,cAAA;EACA,aAAA;EACA,YAAA;ACAF;ADCE;AAAA;IACC,YAAA;IACA,UAAA;ACED;AACF;AD5BA;EA6BE,cAAA;EACA,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;ACEF;ADnCA;EAoCE,yBAAA;ACEF;ADtCA;EAuCE,kBAAA;ACEF;ADzCA;EA2CE,yBAAA;ACCF;AD5CA;EA8CE,cAAA;ACCF;AD/CA;EAiDE,yDAAA;EACA,qBAAA;ACCF;ADnDA;EAsDG,aAAA;ACAH;ADtDA;EAyDG,mBAAA;ACAH;ADzDA;EA6DE,yDAAA;EACA,yBAAA;ACDF;AD7DA;EAiEE,wBAAA;ACDF;ADhEA;EAoEE,gBAAA;ACDF;ADnEA;EAuEE,WAAA;ACDF;ADtEA;EA0EE,WAAA;ACDF;ADzEA;EA6EE,8BAAA;EACA,6BAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kCAAA;EACA,qBAAA;EACA,yBAAA;ACDF;ADnFA;EAwFE,8BAAA;EACA,6BAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kCAAA;EACA,qBAAA;EACA,0BAAA;ACFF;AD7FA;EAkGE,yDAAA;EACA,WAAA;EACA,eAAA;ACFF;ADlGA;EAsGG,mBAAA;ACDH;ADrGA;EAyGG,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;ACDH;AD3GA;EA+GG,gBAAA;EACA,UAAA;ACDH;AD/GA;EAkHI,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;ACAJ;ADCI;EACC,mBAAA;ACCL;ADxHA;EA4HG,gBAAA;ACDH;AD3HA;EA8HI,gBAAA;ACAJ;AD9HA;EAgIK,gBAAA;ACCL;ADIC;AAAA;IAEE,sBAAA;ACFD;ADAD;IAKE,mBAAA;ACFD;ADHD;IAQE,eAAA;ACFD;AACF","sourcesContent":[".breakdown {\n\t.com-mod-module-header {\n\t\tmargin-top: 13px;\n\t\tmargin-bottom: 0px;\n\t\tfont-size: 18px;\n\t\tcolor: #333;\n\t\tfont-family: \"Avenir Next LT W01 Demi\",Arial;\n\t}\n\t.com-mod-module-header-individual{\n\t\tfont-size: 26px;\n\t\tcolor: #333;\n\t\tfont-family: 'AvenirNextLTW01-Regular',Arial;\n\t}\n\t.breakdown-chart-legend {\n\t\tmargin-bottom: 30px;\n\t}\n\t.adjust-down{\n\t\tmargin-top: 20px;\n\t}\n\t.breakdown-chart{\n\t\tdisplay: block;\n\t\theight: 126px;\n\t\twidth: 126px;\n\t\t@media (max-width: 770px){\n\t\t\theight: auto;\n\t\t\twidth: 90%;\n\t\t}\n\t}\n\t.chart-title{\n\t\tcolor: #666666;\n\t\tfont-family: 'Avenir Next LT W01 Demi',Arial;\n\t\tfont-size: 12px;\n\t\tmargin-top: 12px;\n\t\tmargin-bottom: 12px;\n\t}\n\t.adjust-date {\n\t\tmargin: 10px 0px 10px 0px;\n\t}\n\t.app-title {\n\t\tmargin-bottom: 0px;\n\t}\n\n\t.com-mod-section-header {\n\t\tmargin: 15px 0px 20px 0px;\n\t}\n\t.com-mod-table-label {\n\t\tcolor: #666666;\n\t}\n\t.link-container{\n\t\tfont-family: \"Avenir Next LT W01 Demi\",Arial,sans-serif;\n\t\tmargin: 10px 0 10px 0;\n\t}\n\t.sector-exposure {\n\t\timg {\n\t\t\theight: 125px;\n\t\t}\n\t\t.chart-legend-container {\n\t\t\tmargin-bottom: 20px;\n\t\t}\n\t}\n\t.toggle-section-header{\n\t\tfont-family: \"Avenir Next LT W01 Demi\",Arial,sans-serif;\n\t\tmargin: 15px 0px 20px 0px;\n\t}\n\t.flush-top {\n\t\tmargin-top: 0 !important;\n\t}\n\t.table {\n\t\tmargin-top: 10px;\n\t}\n\tli.active h3.com-mod-tab-module-header span.com-mod-table-label {\n\t\tcolor: #000;\n\t}\n\tli h3.com-mod-tab-module-header span.com-mod-table-label {\n\t\tcolor: #eee;\n\t}\n\t.white-arrow-down {\n\t\tborder-bottom: 2px solid white;\n\t\tborder-right: 2px solid white;\n\t\theight: 8px;\n\t\twidth: 8px;\n\t\tmargin: 3px;\n\t\tbackground-color: rgba(0, 0, 0, 0);\n\t\tdisplay: inline-block;\n\t\ttransform: rotateZ(45deg);\n\t}\n\n\t.white-arrow-right {\n\t\tborder-bottom: 2px solid white;\n\t\tborder-right: 2px solid white;\n\t\theight: 8px;\n\t\twidth: 8px;\n\t\tmargin: 3px;\n\t\tbackground-color: rgba(0, 0, 0, 0);\n\t\tdisplay: inline-block;\n\t\ttransform: rotateZ(-45deg);\n\t}\n\t#underlying-funds {\n\t\tfont-family: \"Avenir Next LT W01 Demi\",Arial,sans-serif;\n\t\tcolor: #333;\n\t\tfont-size: 14px;\n\t\t.additional-information {\n\t\t\tmargin-bottom: 20px;\n\t\t}\n\t\t.objective {\n\t\t\tfont-size: 16px;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 20px;\n\t\t\tmargin-bottom: 8px;\n\t\t}\n\t\t.funds {\n\t\t\tlist-style: none;\n\t\t\tpadding: 0;\n\t\t\t.fund {\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 20px;\n\t\t\t\tcolor: #1d5799 !important;\n\t\t\t\tmargin-bottom: 3px;\n\t\t\t\t&:last-of-type {\n\t\t\t\t\tmargin-bottom: 25px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tdl {\n\t\t\tmargin-bottom: 0;\n\t\t\tdd:last-of-type .funds {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\t.fund:last-of-type {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t@media (max-width: 768px) {\n\t\t.pull-right {\n\t\t\tfloat: none !important;\n\t\t}\n\t\t.flush-top {\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\t\t.flush-left-responsive {\n\t\t\tpadding-left: 0;\n\t\t}\n\t}\n}\n\n",".breakdown .com-mod-module-header {\n  margin-top: 13px;\n  margin-bottom: 0px;\n  font-size: 18px;\n  color: #333;\n  font-family: \"Avenir Next LT W01 Demi\", Arial;\n}\n.breakdown .com-mod-module-header-individual {\n  font-size: 26px;\n  color: #333;\n  font-family: 'AvenirNextLTW01-Regular', Arial;\n}\n.breakdown .breakdown-chart-legend {\n  margin-bottom: 30px;\n}\n.breakdown .adjust-down {\n  margin-top: 20px;\n}\n.breakdown .breakdown-chart {\n  display: block;\n  height: 126px;\n  width: 126px;\n}\n@media (max-width: 770px) {\n  .breakdown .breakdown-chart {\n    height: auto;\n    width: 90%;\n  }\n}\n.breakdown .chart-title {\n  color: #666666;\n  font-family: 'Avenir Next LT W01 Demi', Arial;\n  font-size: 12px;\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n.breakdown .adjust-date {\n  margin: 10px 0px 10px 0px;\n}\n.breakdown .app-title {\n  margin-bottom: 0px;\n}\n.breakdown .com-mod-section-header {\n  margin: 15px 0px 20px 0px;\n}\n.breakdown .com-mod-table-label {\n  color: #666666;\n}\n.breakdown .link-container {\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n  margin: 10px 0 10px 0;\n}\n.breakdown .sector-exposure img {\n  height: 125px;\n}\n.breakdown .sector-exposure .chart-legend-container {\n  margin-bottom: 20px;\n}\n.breakdown .toggle-section-header {\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n  margin: 15px 0px 20px 0px;\n}\n.breakdown .flush-top {\n  margin-top: 0 !important;\n}\n.breakdown .table {\n  margin-top: 10px;\n}\n.breakdown li.active h3.com-mod-tab-module-header span.com-mod-table-label {\n  color: #000;\n}\n.breakdown li h3.com-mod-tab-module-header span.com-mod-table-label {\n  color: #eee;\n}\n.breakdown .white-arrow-down {\n  border-bottom: 2px solid white;\n  border-right: 2px solid white;\n  height: 8px;\n  width: 8px;\n  margin: 3px;\n  background-color: rgba(0, 0, 0, 0);\n  display: inline-block;\n  transform: rotateZ(45deg);\n}\n.breakdown .white-arrow-right {\n  border-bottom: 2px solid white;\n  border-right: 2px solid white;\n  height: 8px;\n  width: 8px;\n  margin: 3px;\n  background-color: rgba(0, 0, 0, 0);\n  display: inline-block;\n  transform: rotateZ(-45deg);\n}\n.breakdown #underlying-funds {\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n  color: #333;\n  font-size: 14px;\n}\n.breakdown #underlying-funds .additional-information {\n  margin-bottom: 20px;\n}\n.breakdown #underlying-funds .objective {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20px;\n  margin-bottom: 8px;\n}\n.breakdown #underlying-funds .funds {\n  list-style: none;\n  padding: 0;\n}\n.breakdown #underlying-funds .funds .fund {\n  font-weight: 400;\n  line-height: 20px;\n  color: #1d5799 !important;\n  margin-bottom: 3px;\n}\n.breakdown #underlying-funds .funds .fund:last-of-type {\n  margin-bottom: 25px;\n}\n.breakdown #underlying-funds dl {\n  margin-bottom: 0;\n}\n.breakdown #underlying-funds dl dd:last-of-type .funds {\n  margin-bottom: 0;\n}\n.breakdown #underlying-funds dl dd:last-of-type .funds .fund:last-of-type {\n  margin-bottom: 0;\n}\n@media (max-width: 768px) {\n  .breakdown .pull-right {\n    float: none !important;\n  }\n  .breakdown .flush-top {\n    margin-bottom: 10px;\n  }\n  .breakdown .flush-left-responsive {\n    padding-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
